import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetchEcoRoumingData = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get('/api/eco-roaming/')
      .then((res) => {
        if (res.data) {
          setData(res.data);
        }
      });
  }, []);

  return data;
};

export { useFetchEcoRoumingData };
